import { createContext } from 'react';

import { ModelNameEnum } from '../../../types';

type NavigationBarContextProps = {
  navData: any[];
  selectedNavItem: ModelNameEnum | null;
  navigationItemOnSelect: (eventKey: ModelNameEnum | null, updatePath: boolean) => void;
};

const initialContextValues: NavigationBarContextProps = {
  navData: [],
  selectedNavItem: null,
  navigationItemOnSelect: () => {},
};

/**
 * See {@link NavigationBarContextProps}
 */
const NavigationBarContext = createContext<NavigationBarContextProps>(initialContextValues);

export default NavigationBarContext;
export type { NavigationBarContextProps };
